import React from 'react';
import { FileText } from 'lucide-react';

interface NotesDisplayProps {
  notes: string | null | undefined;
  title?: string;
}

export const NotesDisplay: React.FC<NotesDisplayProps> = ({
  notes,
  title = "Notes"
}) => {
  if (!notes) return null;

  return (
    <div>
      <h2 className="text-lg font-semibold mb-2 flex items-center">
        <FileText className="h-5 w-5 mr-2 text-muted-foreground" />
        {title}
      </h2>
      <p className="text-sm text-muted-foreground whitespace-pre-line space-y-4">{notes}</p>
    </div>
  );
};

export default NotesDisplay;
